import { Router } from '@angular/router';
import { UserRegistrationStatusValue } from '../../../services/api/definitions';
import { Address } from '../../../services/shared/shared-interface';

export interface Auth {
  state: AuthState;
}

export interface AuthState {
  userId: string;
  firstName: string;
  lastName: string;
  adminEmailId:string;
  email: string;
  phoneNumber: string;
  roles: string[];
  customerIds:  string[];
  locations?: Location[];
  primaryLocationGRID?: string;
  adminLocationID? : string;
  company? : string;
  tncUpdated:boolean;
  privacyPolicyUpdated:boolean;
  contactGRID?:string;
  contactID?:string;
  topLevelGrid:string;
}
export interface TMHCorporateAdminAuthState {
  firstName: string;
  lastName: string;
  email: string;
}
export interface Location {
  isParentCompany: boolean;
  companyId: string;
  companyName: string;
  locationId: string;
  locationName: string;
  address: Address;

}

export interface LocationServiceManagementList {
  billingAddress: BillingServiceFilterAddress[];
  serviceAddress: BillingServiceFilterAddress[];
}

export interface LocationOrderManagementList {
  billingAddress: BillingServiceFilterAddress[];
  shippingAddress: BillingServiceFilterAddress[];
}

export interface BillingServiceFilterAddress {
  address: ServiceManagementAddress;
  locationId: string;
  locationLabel: string;
  locationName: string;
  id? : string;
}
export interface ServiceManagementAddress {
    addressLine1:string;
    city: string;
    country: string;
    state: string;
    zip: string;
    zipCode: '';
}
export interface ProfileLocation{
  
  locations:Location[];
  divisionFilterList: Division[];
  groupsList: string[];
  divisionsList: string[];
}

export interface ServiceManagementFilterList{
  
  locationList:LocationServiceManagementList;
  divisionFilterList: ServiceDivision[];
  groupsList: string[];
  divisionsList: string[];
}

export interface OrderManagementFilterList{
  locationList:LocationOrderManagementList;
  divisionFilterList: OrderDivision[];
  groupsList: string[];
  divisionsList: string[];
}
export interface ServiceDivision {
  divisionName: string;
  groups: ServiceGroup[];
}

export interface OrderDivision {
  divisionName: string;
  groups: OrderGroup[];
}

export interface ServiceGroup{
  groupName: string;
  billingAddress: BillingServiceFilterAddress[];
  serviceAddress: BillingServiceFilterAddress[];
}
export interface OrderGroup{
  groupName: string;
  billingAddress: BillingServiceFilterAddress[];
  shippingAddress: BillingServiceFilterAddress[];
}
export interface Division {
  divisionName: string;
  groups: Group[];
}
export interface Group{
  groupName: string;
  locations: Location[];
}
export type RoutingFunction = (router: Router) => Promise<boolean>;
export type StatusValueToRedirectsMap = Map<
  UserRegistrationStatusValue,
  RoutingFunction
>;

export interface ZendeskToken {
	token: string;
  }
